import { CHAIR_RADIUS } from '../../constants/render-constants';
import { transformVertices } from '../matrix-helper';

export const getChairRadiusInDisplayCoords = (worldFactor, modelViewMatrix) => {
    const vertices = [0, 0, 0, CHAIR_RADIUS * worldFactor, 0, 0];
    const transformedVertices = transformVertices(vertices, modelViewMatrix);
    const dx = transformedVertices[3] - transformedVertices[0];
    const dy = transformedVertices[4] - transformedVertices[1];
    const chairRadiusInDisplayCoords = Math.sqrt(dx * dx + dy * dy);

    return chairRadiusInDisplayCoords;
};
